import styled from "styled-components"

import iconCanada from "../images/icon-canada.png"

export const Wrapper = styled.div`
  padding: 1rem;
  margin: 0 auto;
  max-width: 1140px;
  width: 90%;
`

export const IconCanada = styled.img.attrs( {
  src: iconCanada
} )`
  width: 40px;
`

interface DividerProps {
  color: string
}

export const Divider = styled.div<DividerProps>`
  height: 7px;
  position: relative;
  width: 30px;

  &:before {
    background-color: ${ ( props ) => props.color };
    content: "";
    height: 2px;
    position: absolute;
    right: 0;
    top: 0;
    width: 22px;
  }

  &:after {
    background-color: ${ ( props ) => props.color };
    content: "";
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 22px;
  }
`
